export default function Boolean( props ) {

	const c = props.c
	const data = props.data
	const setData = props.setData

	return <span 
		className="material-symbols-outlined"
		style={{ 
			cursor:'pointer', 
			padding:'3px 100px 3px 8px', 
			opacity:data[ c.column_name ] === 't' ? 1 : 0.35,
		}}
		onClick={ e => { 
			const d = { ...data }
			if ( data[ c.column_name ] === 't' ) {
				d[ c.column_name ] = 'f'
			} else {
				d[ c.column_name ] = 't'
			}
			setData( d ) 
		} }
	>
		{ data[ c.column_name ] === 't' 
		  ? 'check_box' 
		  : 'check_box_outline_blank' 
		}
	</span>

}